export const environment = {
  production: true,
  currentVersionId: 'latest',
};
